/**
 * @author 3173
 * @date 2020-09-23
 * @desc 系列化查看
 */
import React from "react";
import { connect } from 'dva';
import { Descriptions } from 'antd';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { WizAuthority } from "../../../common";

let { WizContainer, modelUtils, WizAvatarUpload, ossFileUtils } = framework_tool
let { WizCard, WizSelect, WizForm, Wizmessage, WizRow, WizCol, WizInput, WizSpin ,WizTag,WizTooltip} = component_tool
let { Session } = utils_tool

class LiveInfo extends WizContainer {
  componentName = 'liveInfo'

  constructor(props) {
    super(props)
    const { history } = props
    let detailInfo = {};
    if (history.location && history.location.pathname === '/live/liveList/liveInfo') {
      if (history.location && history.location.record) {
        detailInfo = history.location.record
        Session.set('liveInfo', detailInfo)
      } else {
        detailInfo = Session.get('liveInfo') || {}
      }
    }
    this.state = {
      time: undefined
    }
    this.detailInfo = detailInfo
  }

  _componentDidMount() {
    if (this.detailInfo.id) {
      this.doAction({
        path: 'interactLive/getInfo',
        payload: {
          key: "getLiveInfo",
          apiParams: {
            id: this.detailInfo.id
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    liveInfo: this._getLiveInfoOver.bind(this)
  }

  _getLiveInfoOver(nextProps, nextState) {
    if (nextProps.liveInfo.code == 1) {
      this.detailInfo = nextProps.liveInfo.data;
      nextState.time = new Date().getTime();
    }
    return true;
  }


  authorityInfo = () => {
    let {targetScoreInfo={}} = this.detailInfo
    let {successCount=0,scopeCount=0 } = targetScoreInfo
    return (
      <WizRow>
      <WizCol>
      <WizAuthority value={this.detailInfo.authInfo} mode='Show' showBlock={false} />
      </WizCol>
      <WizCol span={4} style={{marginLeft:10,}}>
                  <WizTag color="cyan">
                    <WizTooltip
                      title={'应参与总人数：'+(scopeCount && scopeCount>0 ? scopeCount : 0)}
                      placement="topLeft"
                    >
                      {scopeCount && scopeCount>0 ? scopeCount : 0}
                    </WizTooltip>
                  </WizTag>
                  <WizTag color="orange">
                    <WizTooltip
                      title={'已参与人数：'+(successCount && successCount>0? successCount : 0)}
                      placement="topLeft"
                    >
                      {successCount && successCount>0? successCount : 0 }
                    </WizTooltip>
                  </WizTag>
                </WizCol>
                </WizRow>
    )
  }

  getImgInfo = () => {
    let record = this.detailInfo
    // let url = ossFileUtils.getOssFile(
    //   record.img,
    //   record.fileName,
    //   record.fileMimeType,
    //   record.fileSize,
    //   record.fileUri,
    // ).url
    let url = getOssFilePath(record.img)
    url = record.img ? url : constants.files.sys_img_loadingFailed;
    return <div style={{ display: 'flex', 'justify-content': 'flex-start', marginRight: 0, }}>
      <div>
        <img height={225} width={400} src={url} />
      </div>
    </div>
  }


  _render() {
    const items = this.detailInfo
    if (items['liveType'] == 1){
      items['liveType'] = "视频直播"
    }else if (items['liveType'] == 2){
      items['liveType'] = "互动直播"
    }else if (items['liveType'] == 3){
      items['liveType'] = "点播"
    }else if (items['liveType'] == 4){
      items['liveType'] = "远程认证"
    }else if (items['liveType'] == 5){
      items['liveType'] = "直播课堂"
    }else if (items['liveType'] == 6){
      items['liveType'] = "远程评估"
    }else if(items['liveType'] == 7) {
      items['liveType'] = '企微会议';
    }else if(items['liveType'] == 8) {
      items['liveType'] = '企微直播';
    }

    let watchType = '';
    if (items['watchType'] == 1){
      watchType = "横屏"
    }else if (items['watchType'] == 2){
      watchType = "竖屏"
    }

    items['state'] == 1 ? items['state'] = "草稿" : items['state'] == 2 ? items['state'] = "预告中" : items['state'] == 3 ? items['state'] = "直播中" : items['state'] == 4 ? items['state'] = "已结束" : ''

    return (
      <React.Fragment>
        <WizSpin tip={'加载中'} spinning={this.props.interactLiveLoading}>
          <WizCard>
            <Descriptions column={1}  bordered={true}>
              <Descriptions.Item label='直播名称'>{items.name}</Descriptions.Item>
              <Descriptions.Item label='开播时间'>{items.startDate}</Descriptions.Item>
              <Descriptions.Item label='结束时间'>{items.endDate}</Descriptions.Item>
              <Descriptions.Item label='直播类型'>{items.liveType}</Descriptions.Item>
              <Descriptions.Item label='观看类型'>{watchType}</Descriptions.Item>
              <Descriptions.Item label='直播分类'>{items.categoryName}</Descriptions.Item>
              <Descriptions.Item label='直播受众'>{this.authorityInfo()}</Descriptions.Item>
              {this.detailInfo && this.detailInfo.liveType === 3 ? null :
                  <Descriptions.Item label='主持人'>{items.hostName}</Descriptions.Item>
              }
              {this.detailInfo && this.detailInfo.liveType === 3 ? null :
                <Descriptions.Item label='主讲人'>{items.speaker}</Descriptions.Item>
              }
              {this.detailInfo && this.detailInfo.liveType === 3 ? null :
                <Descriptions.Item label='是否可回看'>{items.lookingBack && items.lookingBack == 1 ? '是' : '否'}</Descriptions.Item>
              }
              <Descriptions.Item label='直播封面'>{this.getImgInfo()}</Descriptions.Item>
              <Descriptions.Item label='是否允许匿名互动'>{items.anonymous == 1 ? "是":"否"}</Descriptions.Item>
              <Descriptions.Item label='介绍'>{items.intro}</Descriptions.Item>
              <Descriptions.Item label='直播状态'>{items.state}</Descriptions.Item>
              <Descriptions.Item label='创建时间'>{items.createTime}</Descriptions.Item>
            </Descriptions>
          </WizCard>
        </WizSpin>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { interactLive } = state;
  const liveInfo = modelUtils.getModelEntity(interactLive, "getLiveInfo");
  const load = modelUtils.getLoadingState(state, ['interactLive']);
  return {
    liveInfo,
    ...load
  }
};

export default connect(mapStateToProps)(LiveInfo)
